import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getLogger } from '@/idv2/utils/logger';
import { canRecordVideo } from '../../../components/camera/hooks/use-clip-recorder';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import Consent from '../../../id-doc/pages/consent';
import { useSelfieMachine } from '../../context/selfie-context';
import Capture from '../capture';
import Init from '../init';
import Processing from '../processing';
import Retry from '../retry';
type RouterProps = {
  onDone: () => void;
};
const {
  logWarn
} = getLogger({
  name: 'idv2',
  location: 'selfie-router'
});
const Router = t0 => {
  const $ = _c(38);
  const {
    onDone
  } = t0;
  const [state, dispatch] = useSelfieMachine();
  const isDone = state.value === "complete" || state.value === "failure";
  const {
    config
  } = state.context.requirement;
  let t1;
  if ($[0] !== config.kind || $[1] !== config.videoCapture) {
    t1 = config.kind === "selfie" && config.videoCapture === "required" && !canRecordVideo();
    $[0] = config.kind;
    $[1] = config.videoCapture;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cannotRecordRequiredVideo = t1;
  let t2;
  let t3;
  if ($[3] !== isDone || $[4] !== onDone) {
    t2 = () => {
      if (isDone) {
        onDone();
      }
    };
    t3 = [isDone, onDone];
    $[3] = isDone;
    $[4] = onDone;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== cannotRecordRequiredVideo) {
    t4 = () => {
      if (cannotRecordRequiredVideo) {
        logWarn("Selfie requires a video this browser cannot record");
      }
    };
    t5 = [cannotRecordRequiredVideo];
    $[7] = cannotRecordRequiredVideo;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  if (cannotRecordRequiredVideo) {
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <CameraError cause="unsupported-browser" />;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (state.value === "init") {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Init />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  if (state.value === "consent") {
    let t6;
    let t7;
    if ($[12] !== dispatch) {
      t6 = () => dispatch({
        type: "consentReceived"
      });
      t7 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[12] = dispatch;
      $[13] = t6;
      $[14] = t7;
    } else {
      t6 = $[13];
      t7 = $[14];
    }
    let t8;
    if ($[15] !== state.context.authToken || $[16] !== state.context.device || $[17] !== state.context.onboardingConfig.logoUrl || $[18] !== state.context.onboardingConfig.orgName || $[19] !== state.context.onboardingConfig.privacyPolicyUrl || $[20] !== t6 || $[21] !== t7) {
      t8 = <Consent variant="selfie" authToken={state.context.authToken} device={state.context.device} onConsentSubmit={t6} onNavigatedToPrev={t7} tenantLogoUrl={state.context.onboardingConfig.logoUrl} tenantName={state.context.onboardingConfig.orgName} tenantPrivacyPolicyUrl={state.context.onboardingConfig.privacyPolicyUrl} />;
      $[15] = state.context.authToken;
      $[16] = state.context.device;
      $[17] = state.context.onboardingConfig.logoUrl;
      $[18] = state.context.onboardingConfig.orgName;
      $[19] = state.context.onboardingConfig.privacyPolicyUrl;
      $[20] = t6;
      $[21] = t7;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  if (state.value === "requestCameraAccess") {
    let t6;
    if ($[23] !== dispatch) {
      t6 = <CameraAccessRequest variant="selfie" onClose={() => dispatch({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => dispatch({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => dispatch({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => dispatch({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[23] = dispatch;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    return t6;
  }
  if (state.value === "cameraAccessDenied") {
    let t6;
    if ($[25] !== dispatch) {
      t6 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[25] = dispatch;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    let t7;
    if ($[27] !== state.context.device || $[28] !== t6) {
      t7 = <CameraAccessDenied device={state.context.device} onClose={t6} />;
      $[27] = state.context.device;
      $[28] = t6;
      $[29] = t7;
    } else {
      t7 = $[29];
    }
    return t7;
  }
  if (state.value === "cameraErrored") {
    let t6;
    if ($[30] !== dispatch) {
      t6 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[30] = dispatch;
      $[31] = t6;
    } else {
      t6 = $[31];
    }
    const t7 = state.context.cameraErrorCause ?? "other-error";
    let t8;
    if ($[32] !== t6 || $[33] !== t7) {
      t8 = <CameraError onBack={t6} cause={t7} />;
      $[32] = t6;
      $[33] = t7;
      $[34] = t8;
    } else {
      t8 = $[34];
    }
    return t8;
  }
  if (state.value === "capture") {
    let t6;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Capture />;
      $[35] = t6;
    } else {
      t6 = $[35];
    }
    return t6;
  }
  if (state.value === "processing") {
    let t6;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Processing />;
      $[36] = t6;
    } else {
      t6 = $[36];
    }
    return t6;
  }
  if (state.value === "retry") {
    let t6;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Retry />;
      $[37] = t6;
    } else {
      t6 = $[37];
    }
    return t6;
  }
  return null;
};
export default Router;